<template>
  <div>
    <b-form 
      class=" mb-4 "
    >
      <b-row class="d-inline-flex">
        <b-col>
          <b-form-group
            label="Actie"
          >
            <b-form-select
              v-model="action"
              :options="[
                { value: null, text: 'Selecteer actie' },
                { value: 'batch_update', text: 'Batch bijwerken' },
                { value: 'start_management', text: 'Start management' },
                { value: 'end_management', text: 'Stop management' },
                { value: 'proefperiode', text: 'Proefperiode instellen' },
                { value: 'periode', text: 'Periode instellen' }
              ]"
            />
          </b-form-group>
        </b-col>
        <b-col v-if="isCellEditable('start_management')">
          <b-form-group
            label="Start datum"
          >
            <DateInputField
              v-model="batch_values.start_management" 
              placeholder="Leeg"
            />
          </b-form-group>
        </b-col>
        <b-col v-if="isCellEditable('end_management')">
          <b-form-group label="Eind datum">
            <DateInputField
              v-model="batch_values.end_management"
              placeholder="Leeg"
            />
          </b-form-group>
        </b-col>
        <b-col v-if="isCellEditable('proefperiode')">
          <b-form-group
            label="Proefperiode"
            class="mb-0 mr-2"
          >
            <b-form-input
              v-model="batch_values.proefperiode"
              placeholder="Geen proefperiode"
            />  
          </b-form-group>
        </b-col>
        <b-col v-if="isCellEditable('periode')">
          <b-form-group
            label="Periode"
            class="mb-0 mr-2"
          >
            <b-form-input
              v-model="batch_values.periode"
              placeholder="Geen periode"
            />  
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button 
            :variant="selected_ids.length == 0 ? 'dark' : 'success'" 
            :size="selected_ids.length == 0 ? 'sm' : 'lg'"
            :disabled="selected_ids.length == 0"
            @click="updateUnits()"
          >
            Update {{ selected_ids.length }} units
          </b-button>
        </b-col>
      </b-row>
    </b-form>

    <b-table       
      :caption="$route.path"
      :fields="fields"
      :items="units"
      :selectable="selectable"
      :striped="!selectable"
      dark 
      small
      bordered
      hover
      select-mode="multi"
      @row-selected="onRowSelected($event)"
    >
      <!-- template for checkbox column -->
      <template #cell(check-box)="data">
        <b-checkbox
          v-model="data.rowSelected" 
          :disabled="true" 
        />
      </template>
      <template #cell(unit.kenmerk)="data">
        {{ data.value }}
      </template>
      <template #cell(unit.adres)="data">
        {{ data.value }}
      </template>
      <template #cell()="data">
        <span 
          v-if="isCellEditable(data.field.key)" 
          class="text-xl"
        >
          <i 
            v-if="data.rowSelected" 
            class="cui-pencil "
          />
          {{ data.rowSelected ? batch_values[data.field.key] : data.value }}
        </span>
        <span v-else>
          {{ data.value == null ? 'Leeg' : data.value }}
        </span>
      </template>
    </b-table>
  </div>
</template>
<script>
import { serviceMixin } from "@/mixins/serviceMixin";
import DateInputField from '../../components/DateInputField.vue';
import DateInput from '../../components/DateInput.vue';
export default {
    name: 'RelatieUnitsData',
    components: {
        DateInputField,
        DateInput
    },
    mixins: [serviceMixin],
    props: {

    },
    data() {
        return  {
            units: [],
            fields: [],
            selectable: true,
            selected: [],
            action: null,
            batch_values: {
                start_management: null,
                end_management: null,
                periode: 0,
                proefperiode: 0
            }
        }
    },
    computed: {
        api_path() {
            // /settings/relaties/4/units/management => /relaties/4/units/management
            return this.$route.path.replace('/settings', '');
        },
        selected_ids() {
            return this.selected.map(item => item.unit.id);
        }
        
    },
    watch: {},
    mounted () {
        this.getUnits();
    },
    methods: {
      getUnits() {
        this.get(this.api_path).then(
          response => {
            console.log(response.data);
            this.units = response.data.units;
            this.fields = response.data.fields;
          }
        );
      },
      toggleSelected(data) {
        console.log(data);
      },
      onRowSelected(items) {
          console.log(items);
          this.$set(this, "selected", items);
          // if (items.length == 0) {
          //   this.action = null;
          // }
          // set selected 
      },
      isCellEditable(key) {
        if (this.action == null) {
          return false;
        }
        if (this.action == 'batch_update') {
          return true;
        } else {
          return this.action == key;
        }
      },
      updateUnits() {
        // Implement update logic here
        this.post(this.api_path, {
            ...this.batch_values,
            'action': this.action,
            'unitids': this.selected_ids
        }).then(
          response => {
            console.log(response.data);
            if (response.data.result == 'success') {
              this.getUnits();
              this.action = null;
            }
          }
        );
      }
    },
          
}
</script>